export const FILL_LEVEL_MIN = 0;
export const FILL_LEVEL_MAX = 85;

export const FILL_LEVEL_RANGE = {
  min: FILL_LEVEL_MIN,
  max: FILL_LEVEL_MAX,
};

export const ALLOWED_BLOCK_VALUES = ["83", "84", undefined, ""];
export const ALLOWED_SUPPLY_MODES = ["050", "051", "052"];
